/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { ReactComponent as AddingContactsImg } from 'Assets/svg/adding-contacts-img.svg';
import Pagination from 'Components/common/pagination';
import { CreateNewList } from 'Components/common/createNewList';
import { LoadingWrapper } from 'Components/common/loadingWrapper';
import ToolTipWithIcon from 'Components/common/ToolTipWithIcon';
import { advSearchState } from 'Stores/advSearch';
import { userDetail } from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import { myLeadsList } from 'Utils/commonApi';
import { Utils } from 'Utils/utils';
import { LeadsList, RenderLeadsList } from './leadsList';
import EnablePopUp from './ListPage/jobChangesPopUp';
import DropDownForRoleAndUpdates from './ListPage/HoverDropdown';

const NoListsAvailable = props => {
  const {
    title = 'You have not created any lists yet.',
    description = 'Start creating your first list by adding contacts to it.',
    showButton = true,
  } = props;
  return (
    <div className="my-leads no-results-wrap">
      <AddingContactsImg />
      <div className="no-data-text">
        <div>{title}</div>
        <div>{description}</div>
      </div>
      {showButton && (
        <div className="nolist-action-wrap">
          <Link to={CONSTANTS.PAGE_PATH_MAP.CONTACT_SEARCH}>
            <div className="contact-search-btn">Go to Contact Search</div>
          </Link>
        </div>
      )}
    </div>
  );
};

const MyLeadsWrap = observer(props => {
  const { location } = props;
  const [jobChangePopUp, setJobChangePopUp] = useState(false);
  const [showAvailableUpdatesPopUp, setShowAvailableUpdatesPopUp] = useState(
    false,
  );
  const [showMask, setShowMask] = useState(false);
  
  const [activeListType, setActiveListType] = useState(
    new URLSearchParams(location.search).get('tab') === 'shared' ? 'shared' : 'private',
  );
  const [pagination, setPagination] = useState({ page: 1, count: 50 });

  const clearUpgradePopup = event => {
    const eleList = document.getElementsByClassName('show-upgrade-popup');
    if (eleList !== undefined && eleList.length > 0)
      for (let i = 0; i < eleList.length; i += 1)
        eleList[i].classList.remove('show-upgrade-popup');
    const maskEle = document.getElementsByClassName('upgradePopupMask')[0];
    maskEle.classList.remove('showMask');
  };

  const changePageLimit = val => {
    setPagination({ count: val, page: 1 });
  };

  const closeAvailableUpdatesHoverPopUp = () => {
    setShowMask(false);
    setShowAvailableUpdatesPopUp(false);
  };
  const changePage = pageNo => {
    setPagination({ ...pagination, page: pageNo + 1 });
  };

  const closeActionMask = e => {
    if (e !== null && e !== undefined) e.stopPropagation();
    setShowMask(false);
    setShowAvailableUpdatesPopUp(false);
  };
  const setJobChangePopUpFunction = () => {
    setJobChangePopUp(!jobChangePopUp);
  };

  const isSharedListTab = activeListType === 'shared';

  const currentTabItems = userDetail.myLeadList?.filter(data => {
    return isSharedListTab
      ? data.isSharedList && data.memberId !== userDetail.userInfo.memberId
      : !data.isSharedList ||
          (data.isSharedList && data.memberId === userDetail.userInfo.memberId);
  });

  const currentPageItems = currentTabItems?.filter(
    (...args) =>
      args[1] >= (pagination.page - 1) * pagination.count &&
      args[1] < pagination.page * pagination.count,
  );

  const updateAvailable = currentPageItems.some(item => item.jobCount > 0);

  return (
    <div
      className={`my-leads ${isSharedListTab ? 'shared-list' : ''} ${
        userDetail.isContactUpdatesEnabled ? '' : ' updates-disabled'
      }`}
    >
      {!userDetail.isJobChangesEnabled && jobChangePopUp && (
        <EnablePopUp jobChangePopUp popUpFunction={setJobChangePopUpFunction} />
      )}
      <div className="upgradePopupMask" onClick={clearUpgradePopup} />
      <div className="left-section my-leads-content">
        <LeadsList
          activeListType={activeListType}
          setActiveListType={setActiveListType}
        />
      </div>
      <div
        className={`my-leads-list-container  ${
          userDetail.myLeadList.length <= 0 ? 'no-leads-list-container' : ''
        }`}
      >
        <ul
          className={`my-leads-list-headers${
            userDetail.isContactUpdatesEnabled
              ? ''
              : ' contact-updates-disabled'
          }`}
        >
          <li>List Name </li>
          {isSharedListTab && <li>Creator</li>}
          <li>Created</li>
          <li>Contacts</li>
          <li>Last Purchased</li>
          {userDetail.isContactUpdatesEnabled && (
            <li className="available-update-header">
              <div>
                <span>
                  Available Updates
                  <ToolTipWithIcon className="available-updates-tooltip">
                    This column will show the number of contacts
                    <br /> that has updates for the list.
                  </ToolTipWithIcon>
                  {updateAvailable && (
                    <div
                      onClick={() => {
                        setShowAvailableUpdatesPopUp(true);
                        setShowMask(true);
                      }}
                      className="ripple-effect my-leads-ripple-effect"
                    />
                  )}
                </span>
                {showAvailableUpdatesPopUp && (
                  <DropDownForRoleAndUpdates
                    updatedFlag
                    closeHoverPopUp={closeAvailableUpdatesHoverPopUp}
                  />
                )}
              </div>
            </li>
          )}
        </ul>
        {userDetail.myLeadList.length <= 0 ? (
          <NoListsAvailable />
        ) : isSharedListTab && currentTabItems.length === 0 ? (
          <NoListsAvailable
            showButton={false}
            title="There are no shared lists"
            description="The lists that are shared by your team members appear here"
          />
        ) : (
          <div className="leads-list-items">
            <RenderLeadsList
              isSharedListTab={isSharedListTab}
              list={currentPageItems}
              popUpFunction={setJobChangePopUpFunction}
              {...props}
            />
          </div>
        )}
      </div>
      {userDetail.myLeadList.length > 0 && (
        <Pagination
          totalText="Total Lists"
          totalCount={currentTabItems.length}
          rowsPerPage={pagination.count}
          currentPage={pagination.page}
          updateCurrentPage={changePage}
          onRowsPerPageUpdate={changePageLimit}
          rowsPerPageValues={[10, 25, 50, 100].map(data => {
            return { label: data.toString(), value: data };
          })}
        />
      )}
      <div
        className={`bulk-action-mask${showMask ? ' show-mask' : ''}`}
        onClick={closeActionMask}
      />
      <CreateNewList value="leads" />
      <LoadingWrapper
        className="loader"
        show={advSearchState.actionLoader}
        position="fixed"
      />
    </div>
  );
});

const MyLeads = observer(props => {
  // advSearchState.setAppliedFilters();

  const { match, history, location } = props;
  const { params } = match;
  const { id = '' } = params;
  const [loadMyleadsWrapper, setLoadMyLeadsWrapper] = React.useState(false);

  Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_VIEWED, {});

  Utils.stopBodyScroll();

  const afterListBuildingCheckFlow = () => {
    // if (!userDetail.isMyLeadEnabled) {
    //   let listHasPluginHistory = false;
    //   let pluginHistoryId = '';

    //   userDetail.myLeadList.map(item => {
    //     if (item.name === 'Plugin History') {
    //       listHasPluginHistory = true;
    //       pluginHistoryId = item.id;
    //     }
    //   });

    //   if (listHasPluginHistory) {
    //     myLeadsState.setSelectedList({
    //       id: pluginHistoryId,
    //       name: 'Plugin History',
    //     });
    //     history.push(`/my-leads/list/${pluginHistoryId}`);
    //   } else {
    //     history.push('/my-leads/list');
    //   }
    // }
    if (id !== '') {
      const searchParams = new URLSearchParams(location.search);
      const trigger = searchParams.get('trigger');
      const apExportType = searchParams.get('apExportType');
      window.history.replaceState(null, null, '/my-leads');
      history.push(
        `/my-leads/list/${id}?trigger=${trigger}${
          apExportType ? `&apExportType=${apExportType}` : ''
        }`,
      );
    }
    setLoadMyLeadsWrapper(true);
  };

  useEffect(() => {
    if (userDetail.isMyLeadEnabled !== null) afterListBuildingCheckFlow();
  }, [userDetail.isMyLeadEnabled]);

  useEffect(() => {
    myLeadsList();
  }, []);

  return loadMyleadsWrapper ? (
    <MyLeadsWrap {...props} />
  ) : (
    <LoadingWrapper show position="fixed" />
  );
});

export default MyLeads;
